import { SessionHelper } from "@/helpers/utilities/sessionHelper";
import { createPinia, getActivePinia, type Pinia, type PiniaPluginContext } from "pinia";

const resetStore = ({ store }: PiniaPluginContext): void => {
  const initialState = JSON.parse(JSON.stringify(store.$state));
  store.resetStore = () => {
    Object.keys(initialState).forEach(key => {
      if (!initialState.preservableStates?.includes(key)) {
        store.$state[key] = JSON.parse(JSON.stringify(initialState[key]));
      }
    });
  };
};

export default {
  init(): Pinia {
    const pinia = createPinia();
    pinia.use(resetStore);

    SessionHelper.onLogout(() => this.resetStore());
    return pinia;
  },

  resetStore(): void {
    const pinia = getActivePinia();
    if (!pinia) return;
    (pinia as Pinia & { _s: Map<string, { $id: string; resetStore?: () => void }> })._s.forEach(store => {
      if (store.$id !== "settings") {
        store.resetStore?.();
      }
    });
  }
};
